"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webSearchTool = void 0;
const zod_1 = require("zod");
exports.webSearchTool = {
    name: 'webSearch',
    description: `Search the web for information using Google. This provides direct Google search results similar to what you'd see in a browser. Today is ${new Date().toLocaleDateString()}.
        You may call this tool a maximum of 3 times per request. After 3 uses, further calls will return an instruction to stop searching and finalize your answer.
        
        Mark paragraphs with: <span class="search-ref">[1]</span> references to show which search result you are currently using while writing answers.
    `,
    zodSchema: zod_1.z.object({
        prompt: zod_1.z.string().describe('The search query to execute. Use natural language - will be searched as-is for Google-like behavior.'),
        language: zod_1.z.string().optional().describe('The language for the search (optional).')
    }),
    blockStream: false
};
